import React from "react";
import firebase from "../../../config/firebase";
import { connect } from "react-redux";

// API Middlewares
import { getCurrentCompany } from "../../../redux/middlewares/Company/getCompany";

// Draft Rich Editor for Descriptions
import DraftEditor from "../../common/DraftEditor";
// Drag Image Component
import DragImage from "../../common/dragImage";
import { CATEGORIES } from "../../../Utils";

const dummyCategoryObj = () => {
  return CATEGORIES;
};

const dummyRegionsArray = () => {
  return [
    { id: "101", name: "Anywhere (100% Remote) Only" },
    { id: "201", name: "USA Only" },
    { id: "301", name: "North America Only" },
    { id: "401", name: "Europe Only" },
    { id: "501", name: "Americas Only" },
    { id: "601", name: "Canada Only" },
    { id: "701", name: "EMEA Only" },
    { id: "801", name: "Asia Only" },
    { id: "901", name: "Africa Only" },
    { id: "1001", name: "Other" }
  ];
};

class JobDetails extends React.Component {
  constructor(Props) {
    super(Props);
    console.log(this.props.initialData);

    // Setting initialData to
    this.state = {
      jobTitle: this.props.initialData.title || "",
      jobCategory: this.props.initialData.category || "",
      jobType: this.props.initialData.type || "",
      companyHQ: this.props.initialData?.company?.companyHQ || "",
      jobRegionalRestriction: this.props.initialData.location || "",
      howToApply: this.props.initialData.howToApply || "",
      jobSalary: this.props.initialData.salary || "",
      jobDescription: this.props.initialData.description || "",
      companyEmail: "",
      companyName: "",
      companyStatement: "",
      companyLogo: undefined,
      companyWebsiteURL: "",
      companyConfirmationEmail: "",
      companyDescription: "",
      logoLabelText: "Click or drag your photo here to Upload",
      // jobStatus: !this.props.initialData.status || "pending",
      jobStatus: !this.props.initialData.status || "",
      clearInputs: false,
      error: this.props.error,
      emptyFields: {}
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { currentCompany } = this.props;
    if (prevState.clearInputs !== this.state.clearInputs) {
      this.clearAllInputs();
    }
    if (this.props.emptyFields !== prevProps.emptyFields) {
      console.log({ empty: this.props.emptyFields });
      this.setState({ emptyFields: this.props.emptyFields });
    }
    if (currentCompany.name !== prevProps.currentCompany.name) {
      console.log(this.props.currentCompany);
      const storeageRef = firebase.storage();
      const logoRef = storeageRef.refFromURL(currentCompany.logo);
      console.log(logoRef);
      this.setState(
        {
          companyName: currentCompany.name,
          companyStatement: currentCompany.statement,
          companyLogo: currentCompany.logo,
          logoLabelText: logoRef.name,
          companyWebsiteURL: currentCompany.websiteURL,
          companyConfirmationEmail: currentCompany.confirmationEmail,
          companyDescription: currentCompany.description
        },
        () => this.props.onCompleteForm({ ...this.jobDetailsObject() })
      );
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    // Checking if the parent wants to empty the form
    if (nextProps.clearInputs !== prevState.clearInputs) {
      return { clearInputs: nextProps.clearInputs };
    } else return null;
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    // const initialData = { ...this.props.initialData };
    // if (
    //   initialData?.companyLogo &&
    //   typeof initialData.companyLogo != "object"
    // ) {
    //   const storeageRef = firebase.storage();
    //   const logoRef = storeageRef.refFromURL(initialData.companyLogo);
    //   this.setState({ logoLabelText: logoRef.name });
    // }
  }

  //   Making all fields Empty
  clearAllInputs = () => {
    this.setState({
      clearInputs: false,
      jobTitle: "",
      jobCategory: "",
      jobType: "",
      companyHQ: "",
      jobRegionalRestriction: "",
      howToApply: "",
      jobSalary: "",
      companyEmail: "",
      companyName: "",
      companyStatement: "",
      companyLogo: undefined,
      companyWebsiteURL: "",
      companyConfirmationEmail: "",
      jobDescription: "",
      companyDescription: "",
      logoLabelText: "Click or drag your photo here to Upload",
      jobStatus: ""
    });
  };

  //   Object to send on parent for SubmitHandler
  jobDetailsObject = () => {
    return {
      id: this.props.initialData.id,
      jobTitle: this.state.jobTitle,
      jobCategory: this.state.jobCategory,
      jobType: this.state.jobType,
      // companyHQ: this.state.companyHQ,
      jobRegionalRestriction: this.state.jobRegionalRestriction,
      howToApply: this.state.howToApply,
      jobSalary: this.state.jobSalary,
      // companyEmail: this.state.companyEmail,
      // companyName: this.state.companyName,
      // companyStatement: this.state.companyStatement,
      // companyLogo: this.state.companyLogo,
      // companyWebsiteURL: this.state.companyWebsiteURL,
      // companyConfirmationEmail: this.state.companyConfirmationEmail,
      jobDescription: this.state.jobDescription,
      // companyDescription: this.state.companyDescription,
      jobStatus: this.state.jobStatus
    };
  };

  //   Toggle the change of image (Logo)
  onImageChangeHandler = event => {
    const file = event.target.files[0];
    this.setState({ companyLogo: file, logoLabelText: file.name }, () =>
      this.props.onCompleteForm({ ...this.jobDetailsObject() })
    );
  };

  //  For Input Fields
  onChangeHandler = event => {
    this.setState({ [event.target.name]: event.target.value }, () =>
      this.props.onCompleteForm({ ...this.jobDetailsObject() })
    );
  };

  //   Setting Editor returned HTML of Job Description
  handleJobDescription = value => {
    this.setState({ jobDescription: value }, () =>
      this.props.onCompleteForm({ ...this.jobDetailsObject() })
    );
  };

  //   Setting Editor returned HTML of Company Description
  handleCompanyDescription = value => {
    this.setState({ companyDescription: value }, () =>
      this.props.onCompleteForm({ ...this.jobDetailsObject() })
    );
  };

  // Image Drop Handler.
  handleDrop = files => {
    // console.log(files);
    const file = files[0];
    this.setState({ companyLogo: file, logoLabelText: file.name }, () =>
      this.props.onCompleteForm({ ...this.jobDetailsObject() })
    );
  };

  //    event to check the email exists in DB
  onBlurCompanyEmail = e => {
    // console.log(e.target.value);
    if (e.target.value) this.props.getCurrentCompany(e.target.value);
  };

  autoGenerateEmailHandler = e => {
    e.stopPropagation();
    if (this.state.companyName) {
      let lowerCase = this.state.companyName.toLowerCase();
      let name = lowerCase
        .replace(" ", "")
        .replace("/", "")
        .replace("(", "")
        .replace(")", "")
        .replace("@", "");
      this.setState({
        companyEmail: `heyremote.${name}@heyremote.io`
      });
    }
  };

  render() {
    // console.log("State====", this.state);

    const {
      jobTitle,
      jobCategory,
      companyHQ,
      jobRegionalRestriction,
      howToApply,
      jobSalary,
      companyEmail,
      companyName,
      // companyStatement,
      jobType,
      jobStatus,
      //   companyLogo,
      // companyWebsiteURL,
      // companyConfirmationEmail,
      emptyFields
    } = this.state;

    return (
      <React.Fragment>
        {/* -----Job Details Section----- */}
        {this.props.error && (
          <div className="form-error-body">
            <h5 className="error">* {this.props.error}</h5>
          </div>
        )}
        <div className="form-heading">
          <h3>First, tell us about the positon </h3>
          <p className="required-fields">
            <span className="required-dot">•</span> Required Fields
          </p>
        </div>

        <div className="form-body">
          {/* Job Title */}
          <div className="input-container">
            <label>
              Job Title <span className="required-dot">•</span>
            </label>
            <input
              type="text"
              name="jobTitle"
              className={
                emptyFields.hasOwnProperty("jobTitle") ? "emptyInput" : ""
              }
              value={jobTitle}
              onChange={this.onChangeHandler}
            />
            <p>
              Example: “Senior Designer”. Titles must describe one position.
            </p>
          </div>

          {/* Two Columns Container */}

          <div className="flex-row">
            {/* Category */}
            <div style={{ paddingRight: "16px" }}>
              <div className="input-container">
                <label>
                  Category <span className="required-dot">•</span>
                </label>
                <select
                  name="jobCategory"
                  value={jobCategory}
                  className={
                    emptyFields.hasOwnProperty("jobCategory")
                      ? "emptyInput"
                      : ""
                  }
                  onChange={this.onChangeHandler}
                >
                  <option></option>
                  {/* The array of category */}
                  {dummyCategoryObj().map(category => (
                    <option value={category.name} key={category.id}>
                      {category.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Job Type */}
            <div style={{ paddingLeft: "16px" }}>
              <div className="input-container job-type">
                <label>
                  Job Type <span className="required-dot">•</span>
                </label>
                <div
                  style={{ display: "flex", alignItems: "center" }}
                  className={
                    emptyFields.hasOwnProperty("jobType") ? "emptyInput" : ""
                  }
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "33%"
                    }}
                  >
                    <input
                      type="radio"
                      name="jobType"
                      id="Fulltime"
                      value="Fulltime"
                      checked={jobType === "Fulltime" ? true : false}
                      onChange={this.onChangeHandler}
                    />{" "}
                    <label
                      htmlFor="Fulltime"
                      style={{
                        marginLeft: "5%",
                        marginRight: "10%",
                        paddingBottom: "0"
                      }}
                    >
                      Full-Time
                    </label>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "33%"
                    }}
                  >
                    <input
                      type="radio"
                      name="jobType"
                      id="Contract"
                      value="Contract"
                      checked={jobType === "Contract" ? true : false}
                      onChange={this.onChangeHandler}
                    />{" "}
                    <label
                      htmlFor="Contract"
                      style={{ marginLeft: "5%", paddingBottom: "0" }}
                    >
                      Contract
                    </label>
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <input
                      type="radio"
                      name="jobType"
                      id="Internship"
                      value="Internship"
                      checked={jobType === "Internship" ? true : false}
                      onChange={this.onChangeHandler}
                    />{" "}
                    <label
                      htmlFor="Internship"
                      style={{ marginLeft: "5%", paddingBottom: "0" }}
                    >
                      Internship
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-row">
            {/* Company HQ */}
            <div style={{ paddingRight: "16px" }}>
              <div className="input-container">
                <label>
                  Company HQ
                  {/* <span className="required-dot">•</span> */}
                </label>
                <input
                  type="text"
                  name="companyHQ"
                  value={companyHQ}
                  onChange={this.onChangeHandler}
                />
                <p>Example: “Chicago, IL”, “Stockholm, Sweden”</p>
              </div>
            </div>

            {/* Region */}
            <div style={{ paddingLeft: "16px" }}>
              <div
                className="input-container"
                style={{ paddingBottom: "5.5%" }}
              >
                <label>
                  Regional Restrictions <span className="required-dot">•</span>
                </label>

                <select
                  name="jobRegionalRestriction"
                  value={jobRegionalRestriction}
                  className={
                    emptyFields.hasOwnProperty("jobRegionalRestriction")
                      ? "emptyInput"
                      : ""
                  }
                  onChange={this.onChangeHandler}
                >
                  <option></option>
                  {dummyRegionsArray().map(region => (
                    <option key={region.id} value={region.name}>
                      {region.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div className="flex-row">
            <div style={{ paddingRight: "16px" }}>
              <div className="input-container">
                <label>
                  How to Apply <span className="required-dot">•</span>
                </label>
                <input
                  type="text"
                  name="howToApply"
                  className={
                    emptyFields.hasOwnProperty("howToApply") ? "emptyInput" : ""
                  }
                  value={howToApply}
                  onChange={this.onChangeHandler}
                />
                <p>Link To Application Page Or Email Address</p>
              </div>
            </div>

            <div style={{ paddingLeft: "16px" }}>
              <div className="input-container">
                <label>Salary Range</label>
                <input
                  type="text"
                  name="jobSalary"
                  value={jobSalary}
                  onChange={this.onChangeHandler}
                />
                <p>Example: “35,000 PKR to 60,000 PKR”</p>
              </div>
            </div>
          </div>

          {/* job Description Using Draft Editor */}
          <div className="input-container">
            <label>
              Job Description <span className="required-dot">•</span>
            </label>

            <div
              className={`draft-desc ${
                emptyFields.hasOwnProperty("jobDescription") ? "emptyInput" : ""
              }`}
            >
              <DraftEditor
                role="job"
                emptyEditor={this.state.clearInputs}
                jobPreviousDesc={this.state.jobDescription}
                onChangeHandler={value => this.handleJobDescription(value)}
              />
            </div>
            <textarea
              className={`normal-desc ${
                emptyFields.hasOwnProperty("jobDescription") ? "emptyInput" : ""
              }`}
              name="jobDescription"
              value={this.state.jobDescription}
              placeholder="Write Something"
              onChange={this.onChangeHandler}
            ></textarea>
          </div>

          {/* ------COMPANY DETAILS SECTION------ */}
          {/* <div className="form-heading" style={{ display: "block" }}>
            <h3>Tell Us More About Your Company </h3>
            <p
              style={{
                textAlign: "left",
                color: "#000",
                display: "block",
                width: "100%",
                fontSize: "0.8em"
              }}
            >
              Posted before? Just enter your email and logo, all other info will
              be pulled in from your last position!
            </p>
          </div> */}

          {/* Company Fields */}
          {/* <div className="input-container">
            <label>
              Company Email <span className="required-dot">•</span>
              {companyName && (
                <span className="auto-generate-email">
                  <a type="button" onClick={this.autoGenerateEmailHandler}>
                    Auto Generate
                  </a>
                </span>
              )}
            </label>
            <input
              type="email"
              name="companyEmail"
              className={
                emptyFields.hasOwnProperty("companyEmail") ? "emptyInput" : ""
              }
              value={companyEmail}
              onChange={this.onChangeHandler}
              onBlur={this.onBlurCompanyEmail}
            />
            <p>
              To Auto Generate Email, First fill out the Company Name Field.
            </p>
          </div>

          <div className="input-container">
            <label>
              Company Name <span className="required-dot">•</span>
            </label>
            <input
              type="text"
              name="companyName"
              className={
                emptyFields.hasOwnProperty("companyName") ? "emptyInput" : ""
              }
              value={companyName}
              onChange={this.onChangeHandler}
            />
            <p>Enter your company or organization’s name.</p>
          </div>

          */}

          {/* Logo Dragger */}
          {/* <div className="input-container">
            <label>
              Company Logo <span className="required-dot">•</span>
            </label>
            <DragImage handleDrop={this.handleDrop}>
              <div
                className={`company-logo-dragger ${
                  emptyFields.hasOwnProperty("companyLogo") ? "emptyInput" : ""
                }`}
              >
                <input
                  type="file"
                  name="companyLogo"
                  id="companyLogo"
                  onChange={this.onImageChangeHandler}
                />
                <label htmlFor="companyLogo">{this.state.logoLabelText}</label>
              </div>
            </DragImage>
          </div> */}

          {/* <div className="flex-row"> */}
          {/* <div className="input-container" style={{ paddingRight: "16px" }}>
            <label>
              Company's Website URL <span className="required-dot">•</span>
            </label>
            <input
              type="text"
              name="companyWebsiteURL"
              className={
                emptyFields.hasOwnProperty("companyWebsiteURL")
                  ? "emptyInput"
                  : ""
              }
              value={companyWebsiteURL}
              onChange={this.onChangeHandler}
            />
            <p>Example: Https://Mybusiness.Com/</p>
          </div> */}

          {/* <div className="input-container" style={{ paddingLeft: "16px" }}>
              <label>
                Confirmation Email <span className="required-dot">•</span>
              </label>
              <input
                type="email"
                name="companyConfirmationEmail"
                value={companyConfirmationEmail}
                onChange={this.onChangeHandler}
              />
              <p>We’ll Send Your Receipt And Confirmation Email Here.</p>
            </div> */}
          {/* </div> */}

          {/* Company Description Using Draft Editor */}
          {/* <div className="input-container">
            <label>
              Company Description
            </label>

            <div className="draft-desc">
              <DraftEditor
                role="company"
                // companyInitialState={this.props.initialData.companyDescription}
                emptyEditor={this.state.clearInputs}
                onChangeHandler={value => this.handleCompanyDescription(value)}
              />
            </div>
            <textarea
              className="normal-desc"
              name="companyDescription"
              placeholder="Write Something"
              value={this.state.companyDescription}
              onChange={this.onChangeHandler}
            ></textarea>
          </div>

          <hr /> */}

          {/* -----Job Status---- */}
          <div className="input-container job-type">
            <label>
              Job Status <span className="required-dot">•</span>
            </label>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "20%"
                }}
              >
                <input
                  type="radio"
                  name="jobStatus"
                  id="pending"
                  value="pending"
                  checked={jobStatus === "pending" ? true : false}
                  onChange={this.onChangeHandler}
                />{" "}
                <label
                  htmlFor="pending"
                  style={{
                    marginLeft: "5%",
                    marginRight: "10%",
                    paddingBottom: "0",
                    marginBottom: "0"
                  }}
                >
                  Pending
                </label>
              </div>
              <div
                style={
                  // !this.props.user?.admin
                  //   ? {
                  //       opacity: 0.5,
                  //       display: "flex",
                  //       alignItems: "center",
                  //       width: "20%"
                  //     }
                  // :
                  {
                    display: "flex",
                    alignItems: "center",
                    width: "20%"
                  }
                }
              >
                <input
                  type="radio"
                  name="jobStatus"
                  id="active"
                  value="active"
                  disabled={!this.props.user?.admin}
                  checked={jobStatus === "active" ? true : false}
                  onChange={this.onChangeHandler}
                />{" "}
                <label
                  htmlFor="active"
                  style={{
                    marginLeft: "5%",
                    paddingBottom: "0",
                    marginBottom: "0"
                  }}
                >
                  Active
                </label>
              </div>
            </div>
          </div>
          <hr />
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    currentCompany: state.companyReducer.currentCompany,
    user: state.authReducer.user
    // initialData: state.jobFormReducer.jobDetails
  };
};

export default connect(mapStateToProps, { getCurrentCompany })(JobDetails);
